import {useRouter} from 'next/router'
import {memo, useEffect} from 'react'

import {Action, sendAULog} from '@financial/common-logs'
import {omit} from 'rambda'

import {INFLOW_TO_AU_LOG} from '$constants/aulog/bank/inflow'

export const InflowAuSender = memo(function InflowAuSender() {
    const router = useRouter()

    useEffect(() => {
        const {pathname, query} = router
        const {inflow} = query
        if (typeof inflow !== 'string') {
            return
        }
        const inflowAuLog = INFLOW_TO_AU_LOG[inflow]
        if (inflowAuLog) {
            sendAULog(inflowAuLog, Action.View)
            router.replace({pathname, query: omit(['inflow'], query)}, undefined, {shallow: true, scroll: false})
        }
    }, [router])

    return null
})
